export default {"src":"/_next/static/media/seeless.1a0d263e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};